<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--块1-->
			<div v-if="infoData" class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_1">
					<div class="tips_box">
						<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
					</div>
					<div class="tit">CorDx Tyfast Flu A/B & COVID-19</div>
					<div class="tit_s">Multiplex Rapid Test</div>
					<div class="tips_main_box">
						<div class="tips_el">
							<img class="tips_img" src="../../assets/img_public/20240110_1.png" /><span>Nasal Swab</span>
						</div>
						<div class="tips_el">
							<img class="tips_img" src="../../assets/img_public/20240110_2.png" /><span>Use-Friendly</span>
						</div>
						<div class="tips_el">
							<img class="tips_img" src="../../assets/img_public/20240110_3.png" /><span>Multi Target</span>
						</div>
					</div>
					<div class="txt" v-html="infoData.content"></div>
					<div style="padding: 20px 0 10px 0;">
						<div class="btn_box_ty btn_box" @click="goFreeSample">
							Request Free Sample Kit<img src="../../assets/img_h5/组 32@2x.png" />
						</div>
					</div>
				</div>
				<div class="img_box">
					<img :src="infoData.url" @click="showBigImg" />
				</div>
			</div>
			<!--块1-->
			<!--块4-->
			<template v-if="infoData">
				<div v-if="infoData.tags.length > 0" class="block_4"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="list_box">
						<div v-for="(value, index) in infoData.tags" :key="index"
							class="list_el"
							:class="nowList == value.id ? 'actived' : ''"
							@click="listClick(value)"
						>{{ value.catname }}</div>
					</div>
					<div class="content" v-html="nowContent"></div>
				</div>
			</template>
			<!--块4-->
			<!--块2-->
			<div v-if="false" class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Request More Information</div>
				<div class="txt">
					Please fill out form to know more information or to stay up to date on <span>CorDx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test</span>.
				</div>
				<div class="msg_box">
					<div class="title">Contact us</div>
					<div class="block_4_el">
						<div class="left">
							<img src="../../assets/img_h5/icon@2x.png" />
						</div>
						<div class="right">
							5900 Windward Pkwy, Alpharetta, GA 30005
						</div>
					</div>
					<div class="block_4_el">
						<div class="left">
							<img src="../../assets/img_h5/icon@2x.png" />
						</div>
						<div class="right">
							9540 Waples St. #C, San Diego, CA 92121
						</div>
					</div>
					<div class="block_4_el">
						<div class="left">
							<img src="../../assets/img_h5/icon@2x (1).png" />
						</div>
						<div class="right">
							+1 (800) 711-5355
						</div>
					</div>
					<div class="block_4_el">
						<div class="left">
							<img src="../../assets/img_h5/icon@2x (2).png" />
						</div>
						<div class="right">
							<a style="color: #000000 !important;" href="mailto:info@cordx.com">info@cordx.com</a>
						</div>
					</div>
				</div>
				<contact :type="'1'"></contact>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_box">
					<div class="tit">About CorDx</div>
					<div class="txt">
						CorDx, a CorDx Union company, is a biotechnology organization that delivers medical device solutions to healthcare industries and over a billion users in more than 170 countries. It is transforming the global diagnostics industry with innovative R&D solutions, a vertically integrated supply chain, and manufacturing footprints in the United States and around the world. Through its product realization partnerships with leading pharmaceutical companies, CorDx develops, manufactures, and distributes diagnostics and related tools that empower users to monitor and improve their health. Its proprietary line of diagnostics solutions is recognized by families and medical professionals for reliability, affordability, and rapid results.
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact2.vue'  //联系我们
import { productInfo, productCount  } from '@/api/public_h5';
import md5 from 'js-md5';
import { ImagePreview } from 'vant';  //图片放大
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			imgBig: [],
			metaDescription: '',
			metaKeywords: '',
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);//请求产品信息
		productInfo({
			//id: that.$route.query.id,
			custom: that.$route.params.productInfoIds,
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;//设置OG标签
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.imgBig.push(that.infoData.url);
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		goFreeSample() {
			window.location.href = 'https://pages.cordx.com/cordx-tyfast-mutiplex-rapid-test-poc';
		},
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		//联系我们
		goContact() {
			this.$router.push({ path: '/contact', });
		},
		//查看大图
		showBigImg() {
			let that = this;
			ImagePreview({
				closeable: true,
				showIndicators: false,  //轮播指示器
				showIndex: false,
				images: that.imgBig,
				startPosition: 0,
			});
		},
		goBuyNow() {
			let that = this;
			window.open(that.infoData.buy_url);
		},
	}
}
</script>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_1 p{
	margin: 0;
}
</style>
<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块4*/
	.block_4{
		padding: 0px 20px;
		.content{
			padding: 0 20px;
			border: 1px solid #0B318F;
		}
		.list_box{
			.list_el{
				display: inline-block;
				margin: 0 10px 20px 0;
				padding: 10px 20px;
				font-size: 18px;
				background-color: #EFEFEF;
				color: #000000;
				cursor: pointer;
			}
			.list_el.actived{
				color: #ffffff;
				background-color: #0B318F;
			}
		}
	}
	/*块3*/
	.block_3{
		margin-top: 40px;
		background-color: #0B318F;
		.block_3_box{
			padding: 30px 20px 30px 20px;
			.tit{
				padding-bottom: 5px;
				font-size: 48px;
				color: #ffffff;
				border-bottom: 1px solid #ffffff;
			}
			.txt{
				padding-top: 20px;
				color: #ffffff;
				font-size: 18px;
			}
		}
	}
	/*块2*/
	.block_2{
		padding: 58px 20px 20px 20px;
		.msg_box{
			.block_4_el{
				padding-bottom: 25px;
				display: flex;
				align-items: center;
				.left{
					width: 30px;
					img{ width: 100%; }
				}
				.right{
					flex: 1;
					padding-left: 12px;
					font-size: 18px;
				}
			}
			.title{
				padding-bottom: 20px;
				font-size: 34px;
			}
		}
		.txt{
			padding-bottom: 20px;
			font-size: 16px;
			color: #000000;
			span{
				font-size: 16px;
				color: #F16000;
			}
		}
		.tit{
			padding-bottom: 10px;
			color: #F16000;
			font-size: 24px;
		}
	}
	/*块1*/
	.block_1{
		.img_box{
			margin: 42px 20px 20px 20px;
			img{ width: 100%; }
		}
		.bottom_tips{
			text-align: center;
			color: #0B318F;
			font-size: 42px;
		}
		.block_1_1{
			padding: 58px 20px 20px 20px;
			background: linear-gradient(to right, #F2F7FD, transparent);
			.rz_box{
				display: flex;
				align-items: center;
				padding: 20px 0 42px 0;
				div{
					width: 64px;
					margin-right: 30px;
					img{
						width: 100%;
					}
				}
			}
			.tips_main_box{
				align-items: center;
				margin: 10px 0;
				.tips_el{
					line-height: 1;
					padding: 10px 0;
					span{
						position: relative;
						top: 3px;
						color: #0B318F;
						font-size: 18px;
					}
					.tips_img{
						width: 26px;
						margin-right: 6px;
					}
				}
			}
			.tit_s{
				color: #000000;
				font-weight: bold;
				font-size: 24px;
			}
			.tit{
				font-size: 32px;
				padding: 50px 0 8px 0;
				color: #F16000;
				font-weight: bold;
			}
			.tips_box{
				font-size: 16px;
				span{
					font-size: 16px;
					color: #0B318F;
				}
			}
		}
	}
	.btn_box_ty2{
		margin-top: 12px;
		color: #E35B00;
		border: 1px solid #E37900;
		img{
			left: 0;
			margin-right: 8px;
		}
	}
}
</style>
